import { ReactElement } from "react";

export interface RouteData {
    routeProps: RouteProps;
    name: string;
}

export interface RouteProps {
    path: string;
    element: ReactElement<any, any>
}

export interface Action<T> {
    type: string,
    payload: T
}

export interface KeyValuePayload {
    key: string,
    value: any
}

export interface AuthModel {
    username: string,
    password: string,
    token: string,
    institutionCode: string,
    userType?: string
}

export interface ValidatorResponse {
    isValidated: boolean,
    message: string
}

// export interface suggestedProduct {
//     id: string;
//     name: string;
//     route?: string;
//   }

export type PaginationInfo = {
    pageNumber: number,
    pageSize: number,
    fromDate?: string,
    toDate?: string,
    filter?: object
}

export type ReportResponse = {
    data: any,
    pageCount: number,
    perPage: number,
    isSuccessful: boolean,
    currentPageNumber: number,
    total: number,
    message: string
}

export type DropdownOption = {
    label?: string,
    value: string,
    disabled?: boolean
}

export type Fee = {
    id: number,
    name: string,
    lowerBound: number,
    upperBound: number,
    fixedFee: number,
    percentageFee: number,
    minimumFee: number,
    maximumFee: number,
    qorePercentage: number,
    serviceProviderPercentage: number
}

export type ServiceCategory = {
    code: string,
    name: string,
    description: string,
    id: string,
    dateCreated: string,
    dateModified: string,
    status: string,
    createdBy: string,
    createdByIp: string,
    modifiedBy: string,
    modifiedByIp: string,
    availabilityStatus: string
}

export type ServiceProvider = {
    id: number,
    companyName: string,
    description: string,
    websiteURL: string,
    adminUser: {
        username: string,
        firstName: string,
        lastName: string,
        email: string,
        phoneNumber: string
    },
    logo: {
        file: string,
        contentType: string,
        fileName: string
    }
}

export type Product = {
    serviceCategoryId: string,
    serviceProviderId: string,
    name: string,
    description: string,
    features: string,
    logo: string,
    logoUrl: string,
    tooltip: string,
    screenshots: string,
    screenshotUrls: Array<string>,
    configureSetupFee: boolean,
    setupFee: number,
    usageGuide: string,
    termsAndConditions: string,
    isPublished: boolean,
    websiteUrl?: string,
    installed: boolean,
    productStatistic: {
        productId: string,
        installation: number,
        averageRating: number,
        totalRatings: number,
        numberOfRatings: number,
        id: string,
        dateCreated: '2024-10-08T17:27:14.705Z',
        dateModified: '2024-10-08T17:27:14.705Z',
        status: string,
        createdBy: string,
        createdByIp: string,
        modifiedBy: string,
        modifiedByIp: string
    },
    id: string,
    dateCreated: '2024-10-08T17:27:14.705Z,'
    dateModified: '2024-10-08T17:27:14.705Z',
    status: string,
    createdBy: string,
    createdByIp: string,
    modifiedBy: string,
    modifiedByIp: string,
    serviceCategory: {
        name: string,
        code: string,
        description: string
    },
    serviceProvider: {
        code: string,
        companyName: string,
        description: string,
        websiteURL: string,
        logo: string,
        expenseGl: string
    },
    integrationStatus: string
}

export type ServiceFee = {
    serviceProviderId: string,
    serviceCategoryId: string,
    productId: string,
    serviceId: string,
    serviceCode: string,
    feeType: string,
    frequency: string,
    feeList: Array<Fee>,
    id: string,
    dateCreated: string,
    dateModified: string,
    status: string,
    createdBy: string,
    createdByIp: string,
    modifiedBy: string,
    modifiedByIp: string
}

export type OutboundCalls = {
    productId: string,
    productName: string,
    serviceCode: string,
    servicePath: string,
    callTime: string,
    duration: string,
    responseStatus: string,
    responseCode: string,
    responseMessage: string,
    request: string,
    response: string,
    id: string,
    dateCreated: string,
    dateModified: string,
    status: string,
    createdBy: string,
    createdByIp: string,
    modifiedBy: string,
    modifiedByIp: string,
    logoUrl?: string,
    method: string,
    type?: string,
}

export enum UserType {
    CLIENT = 'Institution',
    ADMIN = 'Qore',
    PARTNER = 'ServiceProvider'
}

export type BillingConfig = {
    id: string,
    expenseGL: string,
    qoreAccount: string
}

export type ProductReview = {
    productId: string,
    rating: number,
    comment: string
}

export type ProductRequest = {
    productId: string,
    email: string,
    phoneNumber: string,
    name: string,
    message: string
}

export type Institution = {
    code: string,
    institutionCode: string,
    shortName: string,
    name: string,
    institutionId: number
}

export type Roles = {
    createdBy: string,
    createdByIp: string,
    dateCreated: string,
    dateModified: string,
    description: string,
    id: string,
    modifiedBy: string,
    modifiedByIp: string,
    name: string,
    permissionList: string,
    status: string,
    userType: string
}

export type User = {
    id: string,
    firstName: string,
    lastName: string,
    otherNames: string,
    email: string,
    phoneNumber: number,
    userName: string,
    referenceId: string,
    status: string,
    ssoStatus: string,
    userRoleId: string,
    userType: string,
    isAdmin: false,
    lastLoginTime: string,
    createdBy: string,
    createdByIp: string,
    dateCreated: string,
    modifiedBy: string,
    modifiedByIp: string,
    dateModified: string
}

export type SSOUser =  {
    firstName: string,
    lastName: string,
    email: number,
    ssoTenantId: number,
    id: string,
    dateCreated: "2025-05-22T12:32:44.408Z",
    dateModified: "2025-05-22T12:32:44.408Z",
    status: string,
    createdBy: string,
    createdByIp: string,
    modifiedBy: string,
    modifiedByIp: string
}

export type AvailabilityStatus = {
    id: string,
    label: string,
    value: string
}

export type EmailShare = {
    productId: string,
    emails: string[]
}

export type SharePayload = {
    productId: string;
    recipientEmail?: string;
    institutionCode?: string;
};